interface Action {
    payload: any,
    type: string,
    field: string,
    value?: any,
    validate: boolean
}

const errors: {
    [key: string]: string
} = {
    oldPassword: "Password is required.",
    newPassword: "Password is required.",
    confirmPassword: "Password is required.",
    passwordValidate: "Please add a strong password",
    doesNotMatch: "Passwords do not match."
};

const passwordPattern: {
    [key: string]: any
} = {
    n: /[0-9]/,
    u: /[A-Z]/,
    l: /[a-z]/
};
const passwordLength = 8;


export default (data: any, action: Action) => {
    const newForm = data;
    const prop = newForm[action.field];
    console.log(prop)
    if (prop) {

        if (!prop.added && (action.value || (!action.value && action.validate))) {
            prop.added = true
        }
        if (!prop.dirty && action.validate) {
            prop.dirty = true;
        }
        if ((action.field === 'newPassword' || action.field === 'confirmPassword') && action.value) {
            for (const p in passwordPattern) {
                prop.errTypes[p] = !passwordPattern[p].test(action.value);
            }
            prop.errTypes.min = (action.value || '').length < passwordLength;
            prop.error = Object.values(prop.errTypes).includes(true) ? errors.passwordValidate : null;
        } else {
            prop.error = (prop.added && !action.value && prop.required) ? errors[action.field] : null;
        }
        prop.value = action.value;
        if (newForm.newPassword.value && newForm.confirmPassword.value) {
            newForm.confirmPassword.error =
                (newForm.newPassword.value !== newForm.confirmPassword.value) ? errors.doesNotMatch : null;
        }
    }
    const vals = Object.values(newForm).filter((f: any) => f.required);
    const valid = vals.filter((f: any) => f.added && f.value && !f.error);
    return {
        changed: true,
        valid: valid.length === vals.length,
        data: newForm,
    };
};
